import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import logo from "./images/loading.gif";
import Moment from "moment";
import Mymodal from './modal';
import Cookies from "universal-cookie";
import config from '../config';
const cookies = new Cookies();
const axios = require("axios");
export default class AdminLeaveCancel extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{},
        myitems: [],
        statustext:[],
        revoke:[],
        remove:[],        
        revokepart:[],
        isLoaded: true,
        ErrMsg:<img src={logo} alt="Error"/>,
        ErrMsg2:"",
        today: new Date(),
        EmpID:"",
        isForm: 'none',
        apipath:"",
        DivClass: "ErrDiv"
        }
        this.handlecancel = this.handlecancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handlerevokepartial = this.handlerevokepartial.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);        

    }
    componentDidMount(){
        this.setState({apipath:this.props.apipath});
    }
    handleInputChange = (e)=> {
        this.setState({EmpID: e.target.value});
    }
    handleFocus(event){event.target.select();}
  
    handlerevokepartial(id,i)
    {
        let input= this.state.input;
        let myitems = this.state.myitems;
        input["formid"]=myitems[i]["id"];
        input["type"]=myitems[i]["leavetype"];
        input["days"]=myitems[i]["leavedays"];
        input["from"]=myitems[i]["from_Date"];
        input["to"]=myitems[i]["to_date"];
        input["applydate"]=myitems[i]["applieddate"];        
        this.setState({input});
        this.props.history.push({
            pathname: '/LeaveRevoke',
            data: this.state.input // your data array of objects
          })
    }    

    handlecancel(id,index){
        this.state.statustext[id];
        document.body.style.cursor="wait";
        axios({
            method: 'post',
//            url: cookies.get("phpclass")+'/index.php/user/AdminCancelleave/'+id,
            url: this.state.apipath+'/index.php/user/AdminCancelleave/'+id,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:""});
            if(response.data === "1")
            {
                let item = this.state.statustext;
                item[index] = <span style={{color:'red'}}>Cancelled</span>; 
                this.setState({statustext:item });
                let itemremove = this.state.remove;    
                itemremove[index]="";
                this.setState({remove:itemremove});
            }
            else if(response.data === "0")
            {
                this.setState({DivClass:"ErrDiv"});
                this.setState({ErrMsg2:"Your application might have already been cancelled. Refresh/reload page."});
            }
        })
        .catch((response)=> {
            this.setState({DivClass:"ErrDiv"});
            this.setState({ErrMsg2:"Your request to cancel application is failed, try later please."});

        });      
    }

    handleClick(claimid){
        let input= this.state.input;
        input["ClaimID"] = claimid;
        this.setState({input});
        this.props.history.push({
            pathname: '/medicalform',
            data: this.state.input // your data array of objects
          })
    }
    cur=(num)=> {
        if(num > 0)
    
            return num.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        else
            return "-"
    }
    handleSubmit()
    {
        this.setState({errortext:"",errorcss:"labelerror"});
        if(this.state.EmpID.length < 6)
        {  
            this.setState({errortext:"Invalid employee id",errorcss:"labelerror"});
        }
        else
        {        
            document.body.style.cursor="wait";
            let input=this.state.input;
            input["ID"]=this.state.EmpID;
            this.setState({isLoaded: true, input});    
            axios({
                method: 'post',
                url: this.state.apipath+'/index.php/user/leaveapplist/'+this.state.EmpID,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                document.body.style.cursor="default";
                this.setState({
                isLoaded: true,
                ErrMsg:"",
                isForm:'block',
                myitems: response.data
                });
            })
            .catch((response)=> {
                document.body.style.cursor="default";
                this.setState({isForm:false,ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            });  
        }
    }
    render(){
        let isLoaded = this.state.isLoaded;
        let items = this.state.myitems;    
        let leavedetail="",ardetail="",revoke="",revokepart="",remove="",artext="";
        let todate=new Moment();
        let isForm = this.state.isForm;
        if (isLoaded)         {
            return(
             <div >
                <br></br>
                <table className="csstable" >
                <thead></thead>
                <tbody>
                <tr>
                    <td  width="100px" align="right" padding="2px" >Employee ID:</td>
                    <td width="100px" padding="1px">
                        <input style={{width:100}}
                            autoFocus="autofocus"
                            name="EmpID"
		        	        placeholder="Employee Id"
                            onChange={this.handleInputChange}
                            onFocus={ this.handleFocus}
                        />
                    </td>
                    <td  align="left" paddingtop="15px" height="40px" width="50px">
                        <button onClick={this.handleSubmit} className="btn btn-secondary active">Submit</button>
                    </td>
                </tr>
                <tr>
                    <td  width="100px" ></td>
                    <td colSpan="2" style={{width:"100px",paddingTop:"0px",fontSize:"10pt",align:"left"}}>
                        <span className={this.state.errorcss}>{this.state.errortext}</span>
                    </td>
                </tr>
                </tbody>
                </table>
                <br></br>                             
                <div width="100%" align="center" style={{display:isForm}} >  
                    <div className="inner-profile33" >
                        <span className="box-title">Leave Applications detail</span>
                        <br></br>  
                        <table style={{width:"100%",paddingLeft:"1%",paddingTop:"10px"}}>
                            <thead>
                                <tr className="tr">
                                    <th className="th" scope="col">Reference</th>
                                    <th className="th" scope="col">Application date</th>
                                    <th className="th" scope="col">Leave from</th>
                                    <th className="th" scope="col">Leave to</th>
                                    <th className="th" scope="col">Leave days</th>
                                    <th className="th" scope="col">Leave detail</th>
                                    <th className="th" scope="col">Status</th>
                                    <th className="th" scope="col" colSpan={2}>Revoke</th>
                                    <th className="th" scope="col" colSpan={2}>Action</th>
                                </tr>
                            </thead>
                        <tbody>
                            {
                            items.map((result ,i) => {
                                ardetail="";
                                revoke="";
                                remove="";
                                revokepart="";
                                artext="";
                                todate=new Date(result.to_date);

                                if(result.leavedays > 0 && result.lwp > 0)
                                    leavedetail= result.leavetype+" = "+result.leavedays+", LWP = "+result.lwp;
                                if(result.leavedays > 0 && result.lwp == 0)
                                    leavedetail= result.leavetype+" = "+result.leavedays;
                                if(result.leavedays == 0 && result.lwp > 0)
                                    leavedetail= "LWP = "+result.lwp;
                                if(result.lstatus == null || result.lstatus == -1)
                                {
                                    ardetail = <span id={result.id} style={{color:'black'}}>pending... </span>;
//                                    revoke = <button type='btn' style={{width:60}} onClick={() => {this.handlerevoke(result.id, i)}}>All</button>;    
                                    revokepart ="";
                                }
                                else if(result.lstatus == 1 )
                                {
                                    ardetail = <span id={result.id} style={{color:'green'}}>Approved on {Moment(result.ardate).format("DD/MM/YYYY")}</span>;
                                    remove = <button type='btn' style={{width:60}} onClick={() => {this.handlecancel(result.id, i)}}>Cancel</button>;    
                                    if(todate.getTime() > this.state.today.getTime() && (result.leavetype=='Annual' || result.leavetype=="Sick"))
                                    {
                                        revokepart = <button type='btn' style={{width:60}} onClick={() => {this.handlerevokepartial(result.id, i)}}>Partial</button>;
                                    }
                                    revoke = "";
                                }
                                else if(result.lstatus == 2 )
                                {
                                    ardetail = <span  id={result.id} style={{color:'red'}}>Refused on {Moment(result.ardate).format("DD/MM/YYYY")}</span>;
                                    revokepart = "";
                                    revoke = "";
                                    remove = "";
                                }
                                else if(result.lstatus == 3 )
                                {
                                    ardetail = <span id={result.id} style={{color:'blue'}}>Revoked on {Moment(result.ardate).format("DD/MM/YYYY")}</span>;
                                    revoke = "";
                                    revokepart ="";
                                }
                                else if(result.lstatus == -4 )
                                {
                                    ardetail = <span  id={result.id} style={{color:'red'}}>Cancellation pending </span>;
                                    revokepart = "";
                                    revoke = "";
                                    remove = <button type='btn' style={{width:60}} onClick={() => {this.handlecancel(result.id, i)}}>Resend</button>;    
                                    remove = "";
                                }
                                else if(result.lstatus == 4 )
                                {
                                    ardetail = <span  id={result.id} style={{color:'red'}}>Cancelled </span>;
                                    revokepart = "";
                                    revoke = "";
                                    remove = "";
                                }
                                this.state.statustext.push(ardetail);    
                                this.state.revoke.push(revoke);                 
                                this.state.revokepart.push(revokepart);                 
                                this.state.remove.push(remove);
                                return(
                                    <tr className="trc" key={i}>
                                    <td className="tdm" >{result.id}</td>
                                    <td className="tdm">{Moment(result.applieddate).format("DD/MM/YYYY")}</td>
                                    <td className="tdm">{Moment(result.from_Date).format("DD/MM/YYYY")}, {result.from_time}</td>
                                    <td className="tdm">{Moment(result.to_date).format("DD/MM/YYYY")}, {result.to_time}</td>
                                    <td className="tdm">{Number(result.leavedays)+Number(result.lwp)} day/s</td>
                                    <td className="tdm">{leavedetail}</td>
                                    <td className="tdm">{this.state.statustext[i]}</td>
                                    <td className="tdm" colSpan={2}>{this.state.revoke[i]}{this.state.revokepart[i]}</td>
                                    <td className="tdm" colSpan={2}>{this.state.remove[i]}</td>
                                    </tr>
                                )                        
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        );
    }
    else
    { 
        return(null);
    }
    }
}